<template>
  <div
      class="flex items-end"
      :class="{
          'justify-between': align === 'left',
          'justify-center': align === 'center',
          'justify-end': align === 'right'
      }"
  >
    <label
      class="block font-medium"
      :class="fontSizeClass"
    >{{ translatedLabel }}</label>
    <span
      class="inline-block text-xs opacity-80"
      v-if="required"
    >{{ _mft('form:required') }}</span>
  </div>
</template>
<script>
export default {
  props: {
    label: String,
    size: {
      type: String,
      required: false,
      default: 'sm',
    },
    required: {
      type: Boolean,
      default: false
    },
    align: {
        type: String,
        required: false,
        default: 'left'
    }
  },
    computed: {
      translatedLabel() {
        if (this.label?.match(/^[^\s:]+:[^\s:]+$/)) {
          return _mft(this.label)
        } else {
          return this.label
        }
      },
        fontSizeClass() {
            // Full class names so Tailwind's JIT picks them up
            const sizes = {
                xs: 'text-xs',
                sm: 'text-sm',
                base: 'text-base',
                lg: 'text-lg',
                xl: 'text-xl',
                '2xl': 'text-2xl',
                '3xl': 'text-3xl',
                '4xl': 'text-4xl',
                '5xl': 'text-5xl',
            };
            return sizes[this.size] ?? 'text-sm'
        }
    }
}
</script>
